module.exports = __webpack_public_path__ + "2bff04e39232b99d1c2aa777bd60a59a.png";